export const generateExportFilename = (suffix = '') => {
  const filename =
    new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    })
      .format(new Date())
      .replace(',', '')
      .replaceAll(' ', '_')
      .replaceAll(':', '_') + suffix;
  return filename;
};
